// extracted by mini-css-extract-plugin
export var standaloneTable = "_fh-0";
export var standaloneTableWithBodyFill = "_fh-1";
export var withExtraHeader = "_fh-2";